import { DATOrder } from "../screens/datdocuments/order/state"
import { DATQuotation } from "../screens/datdocuments/quotation/state"
import { DATInvoice } from "../screens/datdocuments/invoice/state"
import { PKGPackagingCustomerChooser } from "../screens/pkgpackaging/packagingcustomerchooser/state"
import { QUTOffering } from "../screens/qutoffering/offering/state"
export let screens = {
  DATInvoice,
  DATOrder,
  DATQuotation,

  PKGPackagingCustomerChooser,

  QUTOffering,
}
